<template>
  <div class="tree-table">
    <table>
<!--      <colgroup>-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--      </colgroup>-->
      <thead>
      <tr>
        <th style="width: 150px;">科目编码</th>
        <th style="width: 150px;">科目名称</th>
        <th style="width: 140px;">单位</th>
        <th style="width: 130px;">调整前数量</th>
        <th style="width: 130px;">调整前单价</th>
        <th style="width: 130px;">调整前金额</th>
        <th style="width: 130px;">调整后数量</th>
        <th style="width: 130px;">调整后单价</th>
        <th style="width: 130px;">调整后金额</th>
        <th style="width: 150px;">备注</th>
<!--        <th>操作</th>-->
      </tr>
      </thead>
      <tbody style="border-left: 1px solid #ddd">
      <tree-row v-for="item in data" :key="item.id" :item="item" :subjectTypeId="subjectTypeId"></tree-row>
      </tbody>
      <tfoot>
      <tr>
        <td>支出小计</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style="text-align: right">{{beforeAdjustPayAmount}}</td>
        <td></td>
        <td></td>
        <td style="text-align: right">{{afterAdjustPayAmount}}</td>
        <td></td>
      </tr>
      <tr>
        <td>税前利润测算</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td style="text-align: right">{{beforeAdjustSaleAmount}}</td>
        <td></td>
        <td></td>
        <td style="text-align: right">{{afterAdjustSaleAmount}}</td>
        <td></td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import ForecastAdjustTreeRow from './forecastAdjustTreeRow.vue';
import Decimal from "decimal.js";

export default {
  name: 'TreeTable',
  components: {
    TreeRow: ForecastAdjustTreeRow
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    subjectTypeId: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      beforeAdjustSaleAmount: 0,
      beforeAdjustPayAmount: 0,
      afterAdjustSaleAmount: 0,
      afterAdjustPayAmount: 0,
    }
  },
  // created() {
  //   this.getSumNum()
  // },
  // mounted() {
  //   this.getSumNum()
  // },
  methods: {
    getSumNum() {
      const validData = this.data.filter(item => item.subjectParentId === '0');
      // 预计算支出和收入总和
      let beforeAdjustSaleAmount = new Decimal(0);
      let beforeAdjustPayAmount = new Decimal(0);
      let afterAdjustSaleAmount = new Decimal(0);
      let afterAdjustPayAmount = new Decimal(0);

      validData.forEach(item => {
        const beforeAmount = new Decimal(item.beforeAdjustAmount || 0);
        const afterAmount = new Decimal(item.afterAdjustAmount || 0);
        if (item.subjectType === '1') {
          beforeAdjustPayAmount = beforeAdjustPayAmount.add(beforeAmount);
          afterAdjustPayAmount = afterAdjustPayAmount.add(afterAmount);
        }
        if (item.subjectType === '0') {
          beforeAdjustSaleAmount = beforeAdjustSaleAmount.add(beforeAmount);
          afterAdjustSaleAmount = afterAdjustSaleAmount.add(afterAmount);
        }
      });
      this.beforeAdjustPayAmount = beforeAdjustPayAmount.toFixed(2, Decimal.ROUND_HALF_UP);
      this.beforeAdjustSaleAmount = beforeAdjustSaleAmount.minus(beforeAdjustPayAmount).toFixed(2, Decimal.ROUND_HALF_UP);
      this.afterAdjustPayAmount = afterAdjustPayAmount.toFixed(2, Decimal.ROUND_HALF_UP);
      this.afterAdjustSaleAmount = afterAdjustSaleAmount.minus(afterAdjustPayAmount).toFixed(2, Decimal.ROUND_HALF_UP);
    }
  }
};
</script>

<style scoped>
.tree-table {
  width: 100%;
  font-size: 12px;
  overflow-x: auto;
  margin: 20px 0;
}

table {
  width: 1370px;
  border-collapse: collapse;
  table-layout: fixed; /* 使表格宽度固定 */
}

th, td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  text-align: center;
}

.child-rows table {
  width: 1370px;
  table-layout: fixed;
}
</style>
